/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Title_PlaceholderInputs */

const en_admin_permissions_title_placeholder = /** @type {(inputs: Admin_Permissions_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Create Posts`)
};

/**
* | output |
* | --- |
* | "e.g. Create Posts" |
*
* @param {Admin_Permissions_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_title_placeholder = /** @type {((inputs?: Admin_Permissions_Title_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Title_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_title_placeholder(inputs)
});
export { admin_permissions_title_placeholder as "admin.permissions.title_placeholder" }